import { breakpoint } from "shared/styles/constants";
import { IFormFieldStyle } from "shared/types";
import styled from "styled-components/macro";

export interface DimensionFieldContainerProps {
  isFullWidth?: boolean;
  style?: IFormFieldStyle;
}

export const DimensionFieldContainer = styled.div<DimensionFieldContainerProps>`
  label + * {
    max-width: ${({ isFullWidth }) => (isFullWidth ? "100%" : "120px")};
  }

  ${breakpoint("s", "down")} {
    ${({ style }) => {
      if (style?.mobile) {
        const { gridColumn } = style.mobile;

        return `
            ${gridColumn ? `grid-column: ${gridColumn} !important;` : ""}
          `;
      }
    }}
  }
`;
